export default __webpack_public_path__ + "static/logo-08f31fdcb5413203b137c7b81c7e08c8.png";